export default __webpack_public_path__ + "static/gold-banner-65e6762dc74db4566936fb194ed4104e.svg";